var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVueJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92.1185,
    height: 92.1185,
    transform: "translate(0 -0.000488281)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5058 24.6006H71.8647L45.9675 69.2732L20.0703 24.6006H30.2997H39.8817L45.9675 34.9595L51.9238 24.6006H61.5058Z",
    fill: "#41B883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0703 24.6006L45.9675 69.2732L71.8647 24.6006H61.5058L45.9675 51.4042L30.2997 24.6006H20.0703Z",
    fill: "#41B883"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2996 24.6006L45.9674 51.5336L61.5057 24.6006H51.9237L45.9674 34.9595L39.8815 24.6006H30.2996Z",
    fill: "#35495E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVueJs);
export default __webpack_public_path__ + "static/media/vueJS.b18eb61f127b7055d2b9c37195579821.svg";
export { ForwardRef as ReactComponent };